export default () => {
  const append = (event: string, ...args: string[]) => {
    // `typeof` guard: optional chaining `ym?.()` still throws ReferenceError when the
    // Yandex.Metrika global was never declared (localhost dev, blocked counter).
    if (typeof ym !== 'undefined') ym(72268654, event, ...args);
  };

  return { append };
};
